import { TextField as MuiTextField } from '@mui/material'
import type { FieldMeta } from '@crm/shared'
import { formatDatetimeInTimezone } from '../../utils/timezones'
import { useAuthStore } from '../../stores/auth.store'

interface DateTimeFieldProps {
  field: FieldMeta
  value: unknown
  mode: 'view' | 'edit'
  onChange?: (value: unknown) => void
  error?: string
  disabled?: boolean
  hideLabel?: boolean
}

export function DateTimeField({ field, value, mode, onChange, error, disabled, hideLabel }: DateTimeFieldProps) {
  const timezone = useAuthStore((s) => s.user?.timezone) ?? 'UTC'

  if (mode === 'view') {
    if (value == null) return <span />
    return <span>{formatDatetimeInTimezone(String(value), timezone)}</span>
  }

  const dtValue = value != null ? String(value).replace(' ', 'T').slice(0, 16) : ''

  return (
    <MuiTextField
      label={hideLabel ? undefined : field.label}
      type="datetime-local"
      value={dtValue}
      onChange={(e) => {
        const v = e.target.value
        onChange?.(v ? v.replace('T', ' ') + ':00' : undefined)
      }}
      error={!!error}
      helperText={error}
      disabled={disabled}
      required={!!field.is_required}
      size="small"
      fullWidth
      slotProps={{ inputLabel: { shrink: true } }}
    />
  )
}
